export function MetricSkeleton() {
  return (
    <div className="card p-5">
      <div className="skeleton h-3 w-16 rounded" />
      <div className="skeleton mt-3 h-9 w-24 rounded" />
      <div className="skeleton mt-3 h-3 w-32 rounded" />
    </div>
  );
}

export function ChartSkeleton({ height = 240 }: { height?: number }) {
  return <div className="skeleton w-full rounded-lg" style={{ height }} />;
}

export function DashboardSkeleton() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <MetricSkeleton key={i} />
        ))}
      </div>
      <div className="card p-5">
        <div className="skeleton h-3 w-32 rounded" />
        <div className="skeleton mt-4 h-[240px] w-full rounded" />
      </div>
    </div>
  );
}
